import { useSelector } from 'react-redux';
import App from 'modules/App';
import { useAction } from 'hooks/useAction';
import * as constants from '../../../../constants';
const formName = constants.PATIENT_SETUP_FORM;
export const usePatientProfileForm = ()=>{
    const formValues = useSelector(App.selectors.formSelector(formName));
    const setFormValue = useAction(App.actions.setFormValue, formName);
    const setFormValues = useAction(App.actions.setFormValues, formName);
    return {
        formName,
        formValues,
        setFormValue,
        setFormValues
    };
};
